import { Controller } from "@hotwired/stimulus"

// Both panels stay in the markup and the tablist starts hidden: without
// JavaScript the page shows both panels and no switch it cannot operate.
const STORAGE_KEY = "linkbucket.platform_tabs"

export default class extends Controller {
  static targets = ["list", "tab", "panel"]

  connect() {
    this.show(this.stored() || this.detected())
    this.listTarget.hidden = false
  }

  select(event) {
    this.pick(event.currentTarget)
  }

  move(event) {
    const tabs = this.tabTargets
    const index = tabs.indexOf(event.currentTarget)
    const steps = { ArrowLeft: -1, ArrowRight: 1, Home: -index, End: tabs.length - 1 - index }
    if (!(event.key in steps)) return

    event.preventDefault()
    const tab = tabs[(index + steps[event.key] + tabs.length) % tabs.length]
    tab.focus()
    this.pick(tab)
  }

  pick(tab) {
    this.show(tab.dataset.platform)
    try {
      localStorage.setItem(STORAGE_KEY, tab.dataset.platform)
    } catch {
      // Storage blocked: the pick lasts for this page only.
    }
  }

  show(platform) {
    if (!this.tabTargets.some((tab) => tab.dataset.platform === platform)) platform = this.detected()

    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.platform === platform
      tab.setAttribute("aria-selected", selected)
      tab.tabIndex = selected ? 0 : -1
    })
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.platform !== platform
    })
  }

  // iPadOS Safari reports itself as a Mac, so the test is for Android and
  // everything else, a computer included, gets the iPhone and iPad panel.
  detected() {
    const platform = navigator.userAgentData?.platform || navigator.userAgent
    return /android/i.test(platform) ? "android" : "ios"
  }

  stored() {
    try {
      return localStorage.getItem(STORAGE_KEY)
    } catch {
      return null
    }
  }
}
